

































import Vue from 'vue'

export default Vue.extend({
  name: 'InputBankName',
  props: {
    bankNameError: String,
    form: Object,
    showBankList: Boolean,
    banks: Array,
    bankNameOptions: Array
  },
  data () {
    return {
      yuuchoHelp: false,
      bankFreeInputDisabled: true,
      bankNameFreeInputedId: 'その他'
    }
  },
  computed: {
    inputBankName: {
      get: function (): string {
        if (this.bankFreeInputDisabled) {
          return ''
        } else {
          return this.form.bankName
        }
      },
      set: () => { /* do nothing */ }
    }
  },
  methods: {
    fillBankCode: function () {
      this.$emit('fillBankCode')
    },
    searchBank (e: HTMLElementEvent<HTMLInputElement>) {
      this.$emit('search', e)
    },
    selectBank: function (bankCode: string, bankName: string) {
      this.$emit('select', bankCode, bankName)
    },
    selectBankFromOptions: function (bankCode: string, bankName: string) {
      // 支店名text、ゆうちょヘルプリンク、その他text入力可否の制御
      this.$emit('clearBankBranchName')
      this.$emit('seenYuuchoHelp', bankName === 'ゆうちょ')
      this.bankFreeInputDisabled = bankName !== 'その他'
      // 「その他」以外選択時はその他textクリアし選択したcode,nameをformにset
      // 「その他」選択時は、ラジオ選択でsetされているであろうformをクリア
      if (bankName !== 'その他') {
        this.$emit('select', bankCode, bankName)
        this.$emit('clearBanks')
      } else {
        this.$emit('select', '', '')
      }
    }
  }
})
